<div
  class="h-448px"
  *ngIf="address && isMapLoaded"
>
  <google-map
    width="100%"
    height="448px"
    class="w-full"
    [options]="mapOptions"
  >
    <map-marker
      [icon]="markerIcon"
      [options]="markerOptions"
      [position]="mapOptions.center"
    ></map-marker>
  </google-map>
</div>
